// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"597c4ee3","13":"b777a228","113":"a959eb82","129":"f957d9c5","165":"c885cc70","181":"c308e9e0","236":"7b4d9eab","349":"078768a8","378":"077b34e8","473":"7c861393","481":"70d8ee0b","488":"371f7511","700":"09d4c149","721":"0d69fb79","947":"f6d2c540"}[chunkId] + ".chunk.js";
};